(() => {
  const reduce = matchMedia('not all');
  const menus = () => [...document.querySelectorAll('[data-mega]')];
  const closeMenus = (except) => menus().forEach(menu => { if (menu !== except) menu.open = false; });
  const setupMenus = (root = document) => {
  root.querySelectorAll('[data-mega]').forEach(menu => {
    if (menu.dataset.menuReady) return;
    menu.dataset.menuReady = 'true';
    const summary = menu.querySelector('summary');
    menu.addEventListener('toggle', () => { if (menu.open) closeMenus(menu); });
    menu.querySelector('[data-mega-close]')?.addEventListener('click', () => { menu.open = false; summary.focus(); });
    menu.querySelectorAll('a').forEach(link => link.addEventListener('click', () => closeMenus()));
    summary.addEventListener('click', event => {
      if (innerWidth <= 1100) return;
      event.preventDefault();
      window.location.assign(summary.dataset.megaUrl);
    });
    summary.addEventListener('focus', () => {
      if (innerWidth > 1100) { closeMenus(menu); menu.open = true; }
    });
    menu.addEventListener('pointerenter', event => {
      if (event.pointerType === 'mouse' && innerWidth > 1100) { closeMenus(menu); menu.open = true; }
    });
  });
  const header = root.querySelector('.site-header');
  if (header && !header.dataset.menuReady) {
    header.dataset.menuReady = 'true';
    header.addEventListener('pointerleave', event => { if (event.pointerType === 'mouse' && innerWidth > 1100) closeMenus(); });
    header.addEventListener('focusout', () => setTimeout(() => { if (!header.contains(document.activeElement)) closeMenus(); }, 0));
  }
  };
  setupMenus();
  document.addEventListener('shopify:section:load', event => setupMenus(event.target));
  document.addEventListener('click', event => { if (!event.target.closest('.site-header')) closeMenus(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const open = menus().find(menu => menu.open);
    closeMenus();
    if (open) open.querySelector('summary').focus();
    else {
      document.querySelector('[data-menu-button]')?.setAttribute('aria-expanded', 'false');
      document.querySelector('[data-nav-links]')?.classList.remove('is-open');
      document.body.classList.remove('menu-open');
    }
  });

  // Animate small content groups within their clipping containers, never move the images independently.
  const motionSeen = new WeakSet();
  const motionObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting || reduce.matches || motionSeen.has(target)) return;
      motionSeen.add(target);
      target.animate([{opacity:0,transform:'translateY(12px)'},{opacity:1,transform:'translateY(0)'}],
        {duration:380,delay:Number(target.dataset.motionDelay || 0),easing:'cubic-bezier(.2,.65,.3,1)'});
      motionObserver.unobserve(target);
    });
  }, {threshold:.08,rootMargin:'0px 0px -20px 0px'}) : null;
  const observeMotion = (root = document) => {
    root.querySelectorAll('.section-heading,.product-card,.pz-intro,.pz-editorial,.home-puzzle-story,.puzzle-scene-card,.cards-destination-scene,.cards-artist-feature,.rr-blog-card,.rr-wall-item,.rr-product-gallery,.rr-product-info').forEach((item,index) => {
      item.dataset.motionDelay = String((index % 3) * 35);
      motionObserver?.observe(item);
    });
  };
  observeMotion();
  reduce.addEventListener('change', () => { if (reduce.matches) document.getAnimations().forEach(animation => animation.finish()); });
  document.addEventListener('shopify:section:load', event => observeMotion(event.target));

  // Each series owns its scroll position; product links and forms remain native.
  const seriesObservers = new Map();
  const initPuzzleRails = (root = document) => {
    root.querySelectorAll('[data-puzzle-series]').forEach(wrap => {
      if (wrap.dataset.railReady) return;
      wrap.dataset.railReady = 'true';
      const rail = wrap.querySelector('[data-puzzle-rail]');
      const prev = wrap.querySelector('[data-puzzle-prev]');
      const next = wrap.querySelector('[data-puzzle-next]');
      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const image = rail.querySelector('.product-media');
        [prev, next].forEach(button => {
          button.hidden = max < 4;
          if (image) button.style.top = (image.getBoundingClientRect().top - wrap.getBoundingClientRect().top + image.getBoundingClientRect().height / 2) + 'px';
        });
        prev.disabled = rail.scrollLeft < 4;
        next.disabled = rail.scrollLeft >= max - 4;
      };
      const move = direction => {
        const origin = rail.getBoundingClientRect().left;
        const positions = [...rail.children].filter(item => item.getBoundingClientRect().width > 0)
          .map(item => item.getBoundingClientRect().left - origin + rail.scrollLeft);
        const target = direction > 0
          ? positions.find(position => position > rail.scrollLeft + 4) ?? rail.scrollWidth
          : positions.reverse().find(position => position < rail.scrollLeft - 4) ?? 0;
        rail.scrollTo({left:target, behavior:reduce.matches ? 'instant' : 'smooth'});
      };
      prev.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      rail.addEventListener('scroll', update, {passive:true});
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(update);
        observer.observe(rail);
        seriesObservers.set(wrap, observer);
      }
      update();
    });
  };
  initPuzzleRails();
  document.addEventListener('shopify:section:load', event => initPuzzleRails(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-puzzle-series]').forEach(wrap => {
      seriesObservers.get(wrap)?.disconnect();
      seriesObservers.delete(wrap);
    });
  });

  const videoObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(({target,isIntersecting}) => {
      if (!isIntersecting || !target.dataset.videoSrc) return;
      target.src = target.dataset.videoSrc;
      delete target.dataset.videoSrc;
      videoObserver.unobserve(target);
    });
  }, {rootMargin:'250px'}) : null;
  const setupVideos = (root = document) => root.querySelectorAll('[data-video-src]').forEach(frame => {
    if (videoObserver) videoObserver.observe(frame);
    else frame.src = frame.dataset.videoSrc;
  });
  setupVideos();
  document.addEventListener('shopify:section:load', event => setupVideos(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-video-src]').forEach(frame => videoObserver?.unobserve(frame)));
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-community-more]');
    if (!button) return;
    const section = button.closest('[data-community-wall]');
    section.classList.add('rr-community-section-expanded');
    button.setAttribute('aria-expanded','true');
    button.hidden = true;
    observeMotion(section);
  });

  const feed = document.querySelector('[data-blog-feed]');
  const loader = document.querySelector('[data-blog-loader]');
  if (feed && loader) {
    let busy = false;
    const status = loader.querySelector('[data-blog-status]');
    const visited = new Set();
    const load = async () => {
      const next = loader.querySelector('[data-blog-next]');
      if (!next || busy) return;
      const url = new URL(next.href,location.href);
      if (location.search.includes('country=US')) url.searchParams.set('country','US');
      if (visited.has(url.href)) return;
      busy = true;
      next.setAttribute('aria-disabled','true');
      status.textContent = 'Loading more articles…';
      try {
        const response = await fetch(url.href,{headers:{Accept:'text/html'}});
        if (!response.ok) throw new Error('Unable to load articles.');
        const page = new DOMParser().parseFromString(await response.text(),'text/html');
        const newFeed = page.querySelector('[data-blog-feed]');
        if (!newFeed) throw new Error('Unable to load articles.');
        const ids = new Set([...feed.querySelectorAll('[data-blog-article]')].map(item=>item.dataset.blogArticle));
        let added = 0;
        newFeed.querySelectorAll('[data-blog-article]').forEach(item => {
          if (!ids.has(item.dataset.blogArticle)) { feed.append(document.importNode(item,true)); added++; }
        });
        visited.add(url.href);
        const upcoming = page.querySelector('[data-blog-next]');
        if (upcoming && added) next.href = upcoming.href;
        else next.remove();
        status.textContent = added ? added + ' more articles loaded.' : 'You’re all caught up.';
        observeMotion(feed);
      } catch {
        status.textContent = 'Could not load more. Tap below to try again.';
        observer?.unobserve(loader);
      } finally {
        busy = false;
        loader.querySelector('[data-blog-next]')?.removeAttribute('aria-disabled');
      }
    };
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      if (entries.some(entry=>entry.isIntersecting)) load();
    }, {rootMargin:'400px'}) : null;
    observer?.observe(loader);
    loader.addEventListener('click', event => { if (event.target.closest('[data-blog-next]')) { event.preventDefault(); load(); } });
  }
})();
